import BaseEnumType from "../../common/base-enum-type";

const TeamLoss = Object.freeze({
    KneelDown: new BaseEnumType("kneelDown", "Kneel Down"),
    Sack: new BaseEnumType("sack", "Sack")
});

export default TeamLoss;
